import React from "react";
import { Box } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css";
import { Autoplay } from "swiper";
import { ChakraBox } from "ui/chakra-framer";
import { SliderCard } from "./slider-card";
import { sliderCards } from "./slider-data";

export function UseCaseSlider() {
  return (
    <Box pos="absolute" bottom={0} left={0} right={0} zIndex={2}>
      <ChakraBox
        cursor="grab"
        pos="relative"
        sx={{
          "& .swiper-wrapper": {
            alignItems: "center",
          },
        }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1, transition: { duration: 0.25, delay: 0.15 } }}
        viewport={{ once: true, amount: "some" }}
      >
        <Swiper
          centeredSlides
          grabCursor
          loop
          slideToClickedSlide
          slidesPerView="auto"
          speed={350}
          modules={[Autoplay]}
          autoplay={{
            delay: 3000,
            waitForTransition: false,
            disableOnInteraction: false,
          }}
        >
          {sliderCards.map((card) => (
            <SwiperSlide
              key={card.title}
              style={{
                width: "auto",
                height: "auto",
              }}
            >
              <SliderCard {...card} />
            </SwiperSlide>
          ))}
        </Swiper>
      </ChakraBox>
    </Box>
  );
}
